 
import { BaseVue } from "@newview/base-web";
import { searchCom } from "@newview/ui";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FilterHelper } from "@newview/tools";
declare let $: any;
@Component({
  name: "treeGrid",
  components: {
    searchCom
  },
  computed: {}
})
export default class GridEdit extends BaseVue {
  @Prop({ default: "" })
  operates!: any; // 模块按钮权限列表
  gridEleId = "treeGrid_" + this.NewGuid();
  defaultColWidth = "50px";
  CheckedRowArray: any = []; //被勾选的行的数据集合
  @Prop({ default: true })
  isToolBar!: Boolean; //是否显示上方工具栏按钮
  @Prop({ default: true })
  isShowAdd!: Boolean; //是否显示添加按钮
  @Prop({ default: true })
  isShowRefresh!: Boolean; //是否显示刷新按钮
  @Prop({ default: true })
  isShowSave!: Boolean; //是否显示保存按钮
  @Prop({ default: false })
  isShowSearch!: Boolean; //是否显示搜索按钮
  @Prop({ default: () => [] })
  toolBarCustom!: Array<Object>; //自定义工具栏按钮列表
  @Prop({ default: "calc(100% - 34px)" })
  gridBoxHeight!: String; //表格高度
  @Prop({ default: false })
  loading!: Boolean; //表格是否处于加载中状态
  @Prop({ default: () => ({}) })
  ColConfig: any | undefined; //列配置参数
  @Prop({ default: true })
  isTableNo!: Boolean; //是否显示序号列
  @Prop({ default: () => [] })
  gridData!: any; //表格数据
  @Prop({ default: "TepId" })
  rowKey!: String; //表格数据key
  @Prop({ default: () => ({}) })
  searchSetting?: any; //搜索条件配置参数
  @Prop({ default: () => ({}) })
  toolBarClick: any | undefined; //默认工具栏点击事件
  @Prop({ default: () => ({}) })
  rowOperation: Object | undefined; //表格行内操作列配置参数
  @Prop({ default: "" })
  delMsgKey!: any; //删除提示语对应列的key
  @Prop({ default: null }) rowClassNameCustom!: any;
  //表格行内操作列配置参数 (合并重新赋值)
  rowOperationNew: any;
  gridBoxHeightNow = this.gridBoxHeight;
  heightnum = 0; //表格具体高度（数字）
  pageNum = 1; //
  searchDisplay = "none"; //搜索框默认隐藏
  currentRow: any = {};
  editData: any = [];
  chKey = "";
  //切换时清空已选择行数据
  empty() {
    this.currentRow = {};
  }
  mounted() {
    let $this = this;
    $this.rowOperationNew = $.extend(
      {
        title: "操作",
        isShow: true,
        cellW: 120,
        isEditBtn: true,
        isDelBtn: true,
        otherBtn: []
      },
      $this.rowOperation
    );
    setTimeout(function() {
      $this.heightnum = $("#" + $this.gridEleId).height();
    }, 100);
    this.editData = JSON.parse(JSON.stringify(this.gridData));
    this.initEditGrid();
  }
  // 监听gridData改变
  @Watch("gridData")
  gridDataChange() {
    console.log("data changes");
    this.editData = JSON.parse(JSON.stringify(this.gridData));
    this.empty();
  }
  initEditGrid() {
    let $this = this;
    this.ColConfig.push({
      title: "",
      key: "DefaultCh",
      width: 1,
      render: (h, params) => {
        return h("div", [
          h(
            "Checkbox",
            {
              props: {
                value: true
              },
              on: {
                input: function(event) {}
              },
              style: {
                display: "none"
              }
            },
            ""
          )
        ]);
      }
    });
    this.ColConfig.forEach(function(item, index) {
      item.renderHeader = (h, params) => {
        return h("div", { style: "width:100%;text-align:center;" }, item.title);
      };
      if (item.colType) {
        switch (item.colType) {
          //ch
          case "ch":
            $this.chKey = item.key;
            item.align = "center";
            item.width = 50;
            item.render = (h, params: any) => {
              let chDisabl = false;
              if (
                (item.noCheckLev && params.row._treeLevel == item.noCheckLev) ||
                params.row._disabled
              ) {
                chDisabl = true;
              }
              // if(params.row._disabled){
              //   chDisabl=true;
              // }
              return h(
                "Checkbox",
                {
                  props: {
                    value: params.row[item.key],
                    disabled: chDisabl,
                    style: "margin:0"
                  },
                  on: {
                    input: function(event) {
                      $this.checkedRows(params.row.Id, event);
                      // $this.$emit("on-check", params.row, event);
                    }
                  }
                },
                ""
              );
            };
            break;
          //文本
          case "ed":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                return h("Input", {
                  props: {
                    value: params.row[item.key]
                  },
                  on: {
                    input: function(event) {
                      params.row[item.key] = event;
                      $this.setData(params.row, item.key, event);
                    }
                  }
                });
              } else {
                return h("span", params.row[item.key]);
              }
            };
            break;
          //数字
          case "num":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let props = $.extend(item.otherParam, {
                  value: params.row[item.key]
                });
                return h("InputNumber", {
                  props: props,
                  on: {
                    input: function(event) {
                      params.row[item.key] = event;
                      $this.setData(params.row, item.key, event);
                    }
                  }
                });
              } else {
                return h("span", params.row[item.key]);
              }
            };
            break;
          //时间选择
          case "date":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                return h("DatePicker", {
                  props: {
                    value: params.row[item.key],
                    type: item.otherParam.type
                  },
                  on: {
                    input: function(event) {
                      params.row[item.key] = $this.ForMatDate(
                        event,
                        item.otherParam.format
                      );
                      $this.setData(
                        params.row,
                        item.key,
                        $this.ForMatDate(event, item.otherParam.format)
                      );
                    }
                  }
                });
              } else {
                return h("span", params.row[item.key]);
              }
            };
            break;
          //下拉列表
          case "selelct":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let sels: any = [];
                item.selectData.forEach(function(selItem, index) {
                  sels.push(
                    h(
                      "Option",
                      {
                        props: {
                          value: selItem.value
                        }
                      },
                      selItem.text
                    )
                  );
                });
                return h(
                  "Select",
                  {
                    props: {
                      filterable:item.filterable?item.filterable:false,
                      value: params.row[item.key]
                    },
                    on: {
                      input: function(event) {
                        params.row[item.key] = event;

                        $this.setData(params.row, item.key, event);
                      },
                      "on-change": e => {
                        $this.$emit("selecte", e, item.key, params.row);
                        // console.log(e)// 改变下拉框赋值
                      }
                    }
                  },
                  sels
                );
              } else {
                return h(
                  "div",
                  FilterHelper.sysDicFilter(
                    params.row[item.key],
                    item.selectData
                  )
                );
              }
            };
            break;
          //自定义编辑
          case "custom":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                return item.editEvent(h, params);
              } else {
                return item.defaultEvent(h, params);
              }
            };
            break;
          default:
            break;
        }
      }
    });
    //操作列
    if (this.rowOperationNew.isShow) {
      this.ColConfig.push({
        title: this.rowOperationNew.title,
        fixed: "right",
        slot: "action",
        width: this.rowOperationNew.cellW,
        align: "center",
        render: (h, params) => {
          let rowbtns: any = [];
          if (this.rowOperationNew.isEditBtn) {
            rowbtns.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  class: "grid-row-btn theme-color",
                  on: {
                    click: () => {
                      if (params.row.$isEdit) {
                        // 是否编辑
                        this.handleHold(params.row);
                      } else {
                        this.handleEdit(params.row);
                      }
                    }
                  }
                },
                params.row.$isEdit ? "取消" : "编辑"
              )
            );
          }
          if (this.rowOperationNew.isDelBtn) {
            rowbtns.push(
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  class: "grid-row-btn theme-color",
                  on: {
                    click: () => {
                      $this.deleteClickRow(params.row);
                      // alert("删除")
                    }
                  }
                },
                "删除"
              )
            );
          }
          if (
            this.rowOperationNew.otherBtn &&
            this.rowOperationNew.otherBtn.length > 0
          ) {
            this.rowOperationNew.otherBtn.forEach(function(item, index) {
              rowbtns.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    class: "grid-row-btn theme-color",
                    on: {
                      click: () => {
                        item.clickEvent();
                      }
                    }
                  },
                  item.name
                )
              );
            });
          }
          return h("div", rowbtns);
        }
      });
    }
  }
  //选中某行
  //param(当前行数据，上次选择行数据)
  currentRowEvent(currentRow, oldCurrentRow,key="Id") {
    if (currentRow.Id > 0 || currentRow.FakeId != "") {
      //
      this.currentRow = currentRow;
      this.$emit("onSelected", currentRow);

      for (const item of this.editData) {
      if (currentRow[key] == item[key]) {
        this.$set(item, "rowIsSelected", true);
      } else {
        this.$set(item, "rowIsSelected", false);
      }
    }
    }
  }

  handleEdit(row) {
    if (this.rowOperationNew.editRowEvent) {
      this.rowOperationNew.editRowEvent(row); //
      return;
    }
    this.changeRowData(row[row.Id ? "Id" : "TemId"], "$isEdit", true);
    // this.$set(row, "$isEdit", true);
  }
  handleHold(row) {
    this.changeRowData(row[row.Id ? "Id" : "TemId"], "$isEdit", false);
    // this.$set(row, "$isEdit", false);
  }
  //搜索框隐藏/显示
  searchToggle() {
    if (this.searchDisplay == "none") {
      this.searchDisplay = "block";
      let searchH = $(".searchDiv").height();
      this.gridBoxHeightNow = this.heightnum - searchH + "px";
      this.heightnum = this.heightnum - searchH;
    } else {
      let searchH = $(".searchDiv").height();
      this.searchDisplay = "none";
      this.gridBoxHeightNow = this.gridBoxHeight;
      this.heightnum = this.heightnum + searchH;
    }
  }
  searchFun(param) {
    let searchParam = "";
    for (const key in param) {
      if (!this.isNull(param[key])) {
        searchParam += key + " like '%" + param[key] + "%' and ";
      }
    }
    searchParam = searchParam.substring(0, searchParam.length - 5);
    if (searchParam.length == 0) {
      searchParam = "1 = 1";
    }
    this.$emit("on-search", searchParam, param);
  }
  //保存方法
  saveFun() {
    let data = this.getTreeGridListData([]);
    if (data.length == 0) {
      return;
    }
    this.toolBarClick.saveFun(data);
  }
  getTreeGridListData(listData, data: any = []) {
    var griddata =
      data.length > 0 ? data : JSON.parse(JSON.stringify(this.editData));
    for (const item of griddata) {
      if (item.isChange) {
        if (item[this.delMsgKey] != "") {
          let tdata = JSON.stringify(item); //深度拷贝
          let xitem = JSON.parse(tdata);
          xitem.children = null;
          if (xitem.Id < 0) xitem.Id = -1;
        if (item.$isAdd) {
          delete item.Id;
        }
          listData.push(xitem);
        }
        //新增的数据删掉Id列
      
        
      }
      if (item.children && item.children.length > 0) {
        this.getTreeGridListData(listData, item.children);
      }
    }
    return listData;
  }
  //行内删除
  deleteClickRow(row) {
    let _this = this;
    if (this.rowOperationNew.delRowEvent && row.Id) {
      this.$Modal.confirm({
        title: "提示",
        content:
          "确定要删除" +
          (this.delMsgKey == "" ? "" : "[" + row[this.delMsgKey]) +
          "]吗?",
        okText: "确认",
        width: "300",
        cancelText: "取消",
        onOk: () => {
          this.rowOperationNew.delRowEvent(row);
        }
      });
    } else {
      this.delTreeListInfoById(row.TemId);
    }
  }

  delTreeListInfoById(Id, data: any = []) {
    let _this = this;
    var griddata = data.length > 0 ? data : this.editData;
    griddata.forEach(function(item: any, index) {
      var id = item.Id ? "Id" : "TemId";
      if (item[id] == Id) {
        griddata.splice(index, 1);
      }
      if (item.children && item.children.length > 0) {
        _this.delTreeListInfoById(Id, item.children);
      }
    });
  }

  //设置编辑数据
  setData(row, key, currentValue, data: any = []) {
    // this.changeRowData(row[row.Id?"Id":"TemId"], key, currentValue)
    // this.changeRowData(row[row.Id?"Id":"TemId"], "$isEdit", true)
    // this.changeRowData(row[row.Id?"Id":"TemId"], "isChange", true)
    let _this = this;
    var griddata = data.length > 0 ? data : this.editData;
    griddata.forEach(function(item: any, index) {
      let id = item.Id ? "Id" : "TemId";
      if (item[id] == row[id]) {
        _this.$set(item, "$isEdit", true);
        _this.$set(item, key, currentValue);
        _this.$set(item, "isChange", true);
      }
      if (item.children && item.children.length > 0) {
        _this.setData(row, key, currentValue, item.children);
      }
    });
  }

  //添加行
  addFun() {
    if (this.toolBarClick.AddFun) {
      this.toolBarClick.AddFun(); //msh 2020 09 25 添加外挂
      return;
    }
    let id = this.NewGuid();
    let Json = {
      TemId: id,
      Id: 0,
      // Token: id,
      PId: this.currentRow.Id ? this.currentRow.Id : 0,
      temPId: this.currentRow.TemId ? this.currentRow.TemId : 0,
      $isEdit: true,
      isChange: true,
      children: [],
      $isAdd: true
    };
    if (!this.currentRow.Id && !this.currentRow.TemId) {
      this.editData.push(Json);
      return;
    } else {
      this.interAddData(this.editData, Json);
    }
  }
  interAddData(data, Json) {
    let finded = false;
    for (let i = 0; i < data.length; i++) {
      var id = this.currentRow.Id ? "Id" : "TemId";
      if (this.currentRow[id] == data[i][id]) {
        data[i]._showChildren = true;
        data[i].children.push(Json);
        finded = true;
        break;
      }
      if (data[i].children) {
        finded = this.interAddData(data[i].children, Json);
        if (finded) break;
      }
    }
    return finded;
  }

  onExpandTree(row_key, status) {
    this.changeRowData(row_key, "_showChildren", status);
  }

  /* *********表格操作方法************* */
  //获取已选中的rowData
  getCheckedRowData() {
    return this.CheckedRowArray;
    // console.log((this as any).$refs.gridTreeCom)
    // return (this as any).$refs.gridTreeCom.getSelection();
  }

  //全部选中/全部不选中
  checkedAll(status) {
    this.CheckedRowArray = [];
    this.checkedAllFun(this.editData, status);
  }
  checkedAllFun(data, status) {
    let _this = this;
    data.forEach(function(item, index) {
      _this.$set(item, _this.chKey, status);
      if (status) {
        _this.CheckedRowArray.push(item);
      }
      if (item.children && item.children.length > 0) {
        _this.checkedAllFun(item.children, status);
      }
    });
  }

  //选中传入Ids行
  checkedRows(Ids, status) {
    if (typeof Ids == "number") {
      Ids = [Ids];
    } else if (typeof Ids == "string") {
      Ids = Ids.split(",");
      for (let index = 0; index < Ids.length; index++) {
        Ids[index] = parseInt(Ids[index]);
      }
    }
    this.checkedRowsFun(this.editData, Ids, status);
  }
  checkedRowsFun(data, Ids, status) {
    // debugger
    let _this = this;
    data.forEach(function(item, index) {
      if ($.inArray(item.Id, Ids) >= 0) {
        _this.$set(item, _this.chKey, status);
        if (status) {
          if (!_this.isRepeatCheckedRow(item)) {
            _this.CheckedRowArray.push(item);
          }
        } else {
          _this.CheckedRowArray.splice(_this.getIndexBySelId(item.Id), 1);
        }
        _this.$emit("on-check", item, status);
      }
      if (item.children && item.children.length > 0) {
        _this.checkedRowsFun(item.children, Ids, status);
      }
    });
  }

  //判断已经被选中的行有无重复
  isRepeatCheckedRow(row) {
    let repeat = false;
    this.CheckedRowArray.forEach(function(item, index) {
      if (row.Id == item.Id) {
        repeat = true;
        return;
      }
    });
    return repeat;
  }
  //获取指定Id在已选中的数据中的下标
  getIndexBySelId(Id) {
    let returnIndex = -1;
    this.CheckedRowArray.forEach(function(item, index) {
      if (Id == item.Id) {
        returnIndex = index;
        return;
      }
    });
    return returnIndex;
  }
  //获取当前选择行数据
  getSelectRow() {
    return this.currentRow;
  }
  //获取当前列表数据源
  getGridData() {
    return this.editData;
  }
  //展开所有
  expandAll() {
    this.rowOpenClose("", true);
  }
  //折叠所有
  collapseAll() {
    this.rowOpenClose("", false);
  }
  //按层级展开20201006
  expandNodeLevel(level = 1, children: any = []) {
    let _this = this;
    let griddata = children.length > 0 ? children : this.editData;
    for (let item of griddata) {
      if (item.NodeLevel) {
        if (item.NodeLevel <= level) {
          _this.$set(item, "_showChildren", true);
          if (item.children && item.children.length > 0) {
            _this.expandNodeLevel(level, item.children);
          }
        } else {
          return;
        }
      } else {
        return;
      }
    }
  }
  //展开指定的行
  openItem(Id) {
    this.rowOpenClose(Id, true);
  }
  //折叠指定的行
  closeItem(Id) {
    this.rowOpenClose(Id, false);
  }
  rowOpenClose(Id, status, data: any = 0) {
    let _this = this;
    let finded = false;
    let griddata = data == 0 ? this.editData : data;
    if (Id != "") {
      for (let item of griddata) {
        if (item.Id == Id) {
          item._showChildren = status;
          finded = true;
          break;
        }
        if (item.children && item.children.length > 0) {
          finded = _this.rowOpenClose(Id, status, item.children);
          if (finded) break;
        }
      }
    } else {
      for (let item of griddata) {
        item._showChildren = status;
        finded = true;
        break;
      }
      // console.log("不处理空ID的展开和收拢");
    }
    return finded;
  }

  //禁止/取消禁止选择指定节点
  disabledItem(Ids, status) {
    if (typeof Ids == "number") {
      Ids = [Ids];
    } else if (typeof Ids == "string") {
      Ids = Ids.split(",");
      for (let index = 0; index < Ids.length; index++) {
        Ids[index] = parseInt(Ids[index]);
      }
    }
    this.disabledItemToggle(Ids, status);
  }
  //取消禁止选择指定节点
  undisabledItem(Id) {
    this.disabledItemToggle(Id, false);
  }
  disabledItemToggle(Ids, status, data: any = 0) {
    let griddata = data == 0 ? this.editData : data;
    for (let item of griddata) {
      if ($.inArray(item.Id, Ids) >= 0) {
        this.$set(item, "_disabled", status);
      }
      if (item.children && item.children.length > 0) {
        this.disabledItemToggle(Ids, status, item.children);
      }
    }
  }

  changeRowData(Id, key, value, data: any = 0) {
    let griddata = data == 0 ? this.editData : data;
    let found = false;
    for (let item of griddata) {
      var id = item.Id ? "Id" : "TemId";
      if (item[id] == Id) {
        this.$set(item, key, value);
        found = true;
        break;
      }
      if (item.children && item.children.length > 0) {
        found = this.changeRowData(Id, key, value, item.children);
        if (found) break;
      }
    }
    return found;
  }
  getParentId(Id, data: any = 0) {
    var PId = -1;
    let found = false;
    let griddata = data == 0 ? this.editData : data;
    for (let item of griddata) {
      if (item.Id == Id) {
        PId = item.PId;
        break;
      }
      if (item.children && item.children.length > 0) {
        PId = this.getParentId(Id, item.children);
        if (PId > 0) break;
      }
    }
    return PId;
  }

  /**
   * @description: 选中某行
   * @param {*} row
   * @return {*}
   */
   setCurrentRow(row, key = "Id") {
    for (const item of this.editData) {
      if (row[key] == item[key]) {
        this.$set(item, "rowIsSelected", true);
      } else {
        this.$set(item, "rowIsSelected", false);
      }
    }
  }
  rowClassName(row, index) {
    if (this.rowClassNameCustom) {
      return this.rowClassNameCustom(row, index);
    } else {
      if (row.itemId && (!row.Id || row.Id == 0)) {
        return "ivu-grid-new-row";
      } else {
        if (row.rowIsSelected) {
          return "ivu-table-row-highlight";
        } else {
          return "";
        }
      }
    }
  }
  
}
